module.exports = __webpack_public_path__ + "static/img/286_TO8_2438.2d2935a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/286_TO8_2438.jpg
// module id = EdBk
// module chunks = 0